import { Fragment } from 'react'

import { MultiViewBlockTab } from '@tribeplatform/react-components/Views'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Checkbox } from '@tribeplatform/react-ui-kit/Checkbox'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'
import { Text } from '@tribeplatform/react-ui-kit/Text'
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle'

export const KitchenSink = () => {
  return (
    <div className="flex flex-col gap-5">
      <Card>
        <Card.Content>
          <div className="grid grid-cols-3 gap-5">
            <Text variant="headingXs">Actions</Text>
            <Text variant="bodyMd" color="subdued">
              Default
            </Text>
            <Text variant="bodyMd" color="subdued">
              Pressed
            </Text>

            <div>Primary button</div>
            <div>
              <Button
                variant="primary"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
              >
                Action
              </Button>
            </div>
            <div>
              <Button
                variant="primary"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
                pressed
              >
                Action
              </Button>
            </div>

            <div>Secondary button</div>
            <div>
              <Button
                variant="secondary"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
              >
                Action
              </Button>
            </div>
            <div>
              <Button
                variant="secondary"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
                pressed
              >
                Action
              </Button>
            </div>

            <div>Secondary neutral button</div>
            <div>
              <Button
                variant="secondaryNeutral"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
              >
                Action
              </Button>
            </div>
            <div>
              <Button
                variant="secondaryNeutral"
                trailingIcon={<SvgIcon name="heart" />}
                fullWidth
                pressed
              >
                Action
              </Button>
            </div>

            <div>Tabs</div>
            <MultiViewBlockTab>Tab 1</MultiViewBlockTab>
            <MultiViewBlockTab pressed>Tab 2</MultiViewBlockTab>

            <div>Link</div>
            <Link>Read more</Link>
            <Link>Read more</Link>

            <div>Checkbox</div>
            <Checkbox size="md" title="Label" />
            <Checkbox size="md" title="Label" defaultChecked />

            <div>Radio button</div>
            <RadioGroup>
              <RadioGroup.Item value="radio1" title="Label" />
            </RadioGroup>
            <RadioGroup defaultValue="radio1">
              <RadioGroup.Item value="radio1" title="Label" />
            </RadioGroup>

            <div>Toggle</div>
            <Toggle />
            <Toggle defaultChecked />
          </div>
        </Card.Content>
      </Card>

      <Card>
        <Card.Content>
          <div className="grid grid-cols-3 gap-5">
            <Text variant="headingXs">Text inputs</Text>
            <Text variant="bodyMd" color="subdued">
              Default
            </Text>
            <Text variant="bodyMd" color="subdued">
              Disabled
            </Text>

            <div>Input field</div>
            <FormControl.Input
              name="input1"
              label="Label"
              helperText="This is a hint text to help user."
              placeholder="Placeholder"
            />
            <FormControl.Input
              name="input1"
              label="Label"
              helperText="This is a hint text to help user."
              placeholder="Placeholder"
              disabled
            />
          </div>
        </Card.Content>
      </Card>

      <Card>
        <Card.Content>
          <div className="grid grid-cols-3 gap-5">
            <Text variant="headingXs" className="col-span-3">
              Headings
            </Text>

            {(
              [
                'heading2xl',
                'headingXl',
                'headingLg',
                'headingMd',
                'headingSm',
                'headingXs',
              ] as const
            ).map(variant => (
              <Fragment key={variant}>
                <div>{variant}</div>
                <Text variant={variant} className="col-span-2">
                  This is {variant} title
                </Text>
              </Fragment>
            ))}

            <div>Body</div>
            <Text variant="bodyMd" className="col-span-2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Text>
          </div>
        </Card.Content>
      </Card>

      <Card>
        <Card.Content>
          <div className="grid grid-cols-3 gap-5">
            <Text variant="headingXs" className="col-span-3">
              Alerts
            </Text>

            <div>Highlight</div>
            <Alert status="info" className="col-span-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum similique veniam.
            </Alert>

            <div>Error</div>
            <Alert status="error" className="col-span-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum similique veniam.
            </Alert>

            <div>Warning</div>
            <Alert status="warning" className="col-span-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum similique veniam.
            </Alert>

            <div>Success</div>
            <Alert status="success" className="col-span-2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
              pariatur, ipsum similique veniam.
            </Alert>
          </div>
        </Card.Content>
      </Card>
    </div>
  )
}
